export enum BSBuildingMorphologyEnum {
  RECTANGLE = "RECTANGLE",
  L = "L",
}

export const bsBuildingMorphologyLabelEnum = {
  [BSBuildingMorphologyEnum.RECTANGLE]: "Rectangle",
  [BSBuildingMorphologyEnum.L]: "Forme en L",
}
